import * as Yup from "yup"

export const userCustomFieldCategoryValidationSchema = (t: any) => Yup.object().shape({
  name: Yup.string().required(t("settings.user.category_is_required", "Category name is required")),
  active: Yup.boolean().required(t("settings.user.field_is_required", "Field is required"))
})

export const userCustomFieldValidationSchema = (t: any) => Yup.object().shape({
  name: Yup.string().required(t("global.name_is_required", "Name is required")),
  valueFields: Yup.array()
    .of(Yup.object().shape({
      name: Yup.string().required(t("settings.user.field_name_is_required", "Field name is required.")),
      type: Yup.string().required(t("settings.user.type_is_required", "Field type is required")),
      isRequired: Yup.boolean().required(t("settings.user.required_field_is_required", "Required field is required")),
    }))
    .min(1, t("settings.user.at_least.field_is_required", "At least one field is required"))
    .test(
      "all-fields-required",
      t("settings.user.all_fields_must_have_a_type", "All fields must have a type"),
      (value) => value?.every((val) => val.type !== "")
    ),
  userCustomFieldCategoryId: Yup.number()
    .required(t("settings.user.category_is_required", "Category is required"))
    .integer(t("settings.user.category_is_required", "Category is required"))
    .positive(t("settings.user.category_is_required", "Category is required")),
  active: Yup.boolean().required(t("settings.user.field_is_required", "Field is required"))
})